import {observer} from "mobx-react";
import {App} from "./App";
import {SlsCreatePage, SlsOverviewPage, SlsTabType, SlsWarehouseCreatePage,} from "../page/sls";
import {SlsDetailPage} from "../page/sls";
import {SlsWarehouseDetailPage} from "../page/sls/SlsWarehouseDetailPage";

interface SlsAppProps {
    mode: 'overview' | 'create' | 'detail' | 'warehouse-create' | 'warehouse-detail'
    tab?: SlsTabType
}

const SlsApp = observer(function CmsApp({mode, tab}: SlsAppProps) {
    return <App>
        {mode === 'overview' && <SlsOverviewPage tab={tab}/>}
        {mode === 'create' && <SlsCreatePage/>}
        {mode === 'detail'&& <SlsDetailPage/>}
        {mode === 'warehouse-create' && <SlsWarehouseCreatePage/>}
        {mode === 'warehouse-detail' && <SlsWarehouseDetailPage/>}
    </App>
})

export {
    SlsApp
}
